// Public Deploy tokens only. JWT signing keys stay on prize_engine.
// Both builds select this configuration through the current site's LICENCE_CONFIG.
export interface FreshdeskPublicWidgetConfig {
  host: string;
  token: string;
  widgetId: string;
  iconUrl?: string;
}

export interface FreshdeskBrandConfig {
  licence: string;
  enabled: boolean;
  // Omit to use the site's backend, including its current production mirror.
  apiOrigin?: string;
  vipRoles: readonly string[];
  standard: FreshdeskPublicWidgetConfig;
  vip: FreshdeskPublicWidgetConfig | null;
}

export const FIREBALL_FRESHDESK: FreshdeskBrandConfig = {
  "licence": "fireball",
  "enabled": true,
  "vipRoles": [
    "vip",
    "super_vip",
    "supervip",
    "potential_vip",
    "pvip fb",
    "vip fb",
    "svip fb"
  ],
  "standard": {
    "host": "https://playbison.freshdesk.com",
    "token": "01KVYPMTXBK9HQ1NSRJF1SZFEJ",
    "widgetId": "01M46ARHPHFM50P9CTCPCFKN6X"
  },
  "vip": {
    "host": "https://playbison.freshdesk.com",
    "token": "01KVYPMTXBK9HQ1NSRJF1SZFEJ",
    "widgetId": "01M46AY4P0RTF299DNJSXXFZKV"
  }
};

export const METEORO_FRESHDESK: FreshdeskBrandConfig = {
  "licence": "meteoro",
  "enabled": true,
  "apiOrigin": "https://prizeengine.meteoro.casino",
  "vipRoles": [],
  "standard": {
    "host": "https://playbison.freshdesk.com",
    "token": "01KVYPMTXBK9HQ1NSRJF1SZFEJ",
    "widgetId": "01M46AYH35DTV8H7H76ZPBNMTD"
  },
  "vip": {
    "host": "https://playbison.freshdesk.com",
    "token": "01KVYPMTXBK9HQ1NSRJF1SZFEJ",
    "widgetId": "01M46AYM8NE6FP7VX721E1D74X"
  }
};
